import React from 'react'
import styled from 'styled-components'

import MainButton from '../buttons/mainButton'
import vertical from '../../images/new_back_3.png'
import horizontal from '../../images/collage_04.png'

const Container = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  position: relative;
  border-radius: 15px 15px 15px 0px;

  h1 {
    text-transform: uppercase;
    margin-bottom: 35px;
  }

  h3 {
    font-size: 20px;
    line-height: 30px;
    font-family: 'Flama Book';
    margin-bottom: 35px;
  }

  @media only screen and (max-width: 600px) {
    padding: 30px;
    border-radius: 0;
  }

  @media only screen and (min-width: 601px) and (max-width: 1000px) {
    padding: 40px;
    width: 84%;
    margin-left: 8%;
  }

  @media only screen and (min-width: 601px) and (max-width: 700px) {
    padding-top: 220px;
  }

  @media only screen and (min-width: 701px) and (max-width: 1000px) {
    padding-top: 300px;
  }

  @media only screen and (max-width: 1000px) {
    h1 {
      margin-bottom: 35px;
      font-size: 38px;
      line-height: 36px;
    }
  }

  @media only screen and (min-width: 1001px) {
    padding: 50px;
    padding-right: 500px;
    max-width: 1080px;
  }
`

const Image = styled.div`

  position: absolute;

  @media only screen and (max-width: 1000px) {
    right: 0;
    margin-right: -15%;
    width: 130%;
    background: url(${horizontal});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    //background-color: rgba(0,0,0,0.3);
  }

  @media only screen and (min-width: 1001px) {
    right: 50px;
    width: 400px;
    height: 650px;
    background: url(${vertical});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  @media only screen and (max-width: 600px) {
    display: none;
  }

  @media only screen and (max-width: 700px) {
    top: -40px;
    height: 220px;
  }

  @media only screen and (min-width: 701px) and (max-width: 1000px) {
    top: -40px;
    height: 280px;
  }
`

const WelcomeScreen = (props) => {

  const { h1, h2, button } = props.copy.welcomeScreen

  return(
    <Container>
      <h1>{h1}</h1>
      <h3>{h2}</h3>
      <MainButton label={button} action={() => props.action()} />
      <Image />
    </Container>
  )
}

export default WelcomeScreen
